export default __webpack_public_path__ + "login_bg.57db73f.jpg";